import { get } from "../../service/api";

/**
 * @param {"last14"|"yesterday"} mode
 */
const getTrafficPeak = async (mode = "last14") => {
  const response = await get(
    `/admin/trafficPeak?mode=${encodeURIComponent(mode)}`
  );
  return response;
};

export default getTrafficPeak;
